import React from "react";
import AdminForm from "./AdminForm";
import { useParams } from "react-router-dom";
import { useGetAdminById } from "../../queries/useAdmin";
import BackDropFullScreen from "../../components/BackDropFullScreen";

function AdminDetailPage() {
  const { adminId } = useParams<{ adminId: string }>();
  const { data: admin, isLoading } = useGetAdminById(parseInt(adminId));

  return (
    <div>
      <AdminForm action={"DETAIL"} admin={admin} />
      <BackDropFullScreen isOpen={isLoading} />
    </div>
  );
}

export default AdminDetailPage;
